import { convertTimezone } from '@/shared/lib/helpers/convert-timezone.helper';
import { dateFormat } from '@/shared/lib/helpers/date-format.helper';

import { DownloadHistoricalDataResponse } from '../types/historical-data.interface';

export const transformHistoricalDataResponse = (response: DownloadHistoricalDataResponse[], timezone: string) =>
	response.map(({ id, status, url, job_uuid, start_time, end_time, file_format, created_at }) => ({
		id,
		status,
		url,
		start: start_time ? dateFormat(new Date(start_time)) : ' ',
		end: end_time ? dateFormat(new Date(end_time)) : ' ',
		jobUuid: job_uuid,
		fileFormat: file_format,
		createdAt: created_at ? dateFormat(convertTimezone(created_at, timezone)) : ' ',
	}));
